<template> 
  <section class="review">    
    <header class="review__header">
      <span class="review__user">
          <span class="review__avatar">
            {{ reviewer_initials }}
          </span>
          <span class="review__name">{{ reviewer }}</span> 
      </span>

      <span class="review__info">
        <span class="review__data">
          <span v-if="max_rating" 
            :style="{'border-right': (date ? 1 : 0) + 'px solid silver'}"
            class="review__data-rating" 
          >
            {{ rating || 0 }}/{{ max_rating }}
          </span>
          <span v-else 
              :style="{'border-right': (date ? 1 : 0) + 'px solid silver'}"
              class="review__data-rating" 
          >
            {{ (rating || 0).toFixed(1) }}
          </span>
          <span v-if="date" class="review__data-date">{{ date }}</span>
        </span>
        <span v-if="additional_data" class="review__additional">{{ additional_data }}</span>
      </span>
    </header>
    <main class="review__main">
      <span v-if="title" class="review__title">{{ title }}</span>
      <blockquote v-if="content" :class="truncate ? 'review__content-preview' : 'review__content'">{{ content }}</blockquote>
    </main>
    <footer class="review__footer">
      <!-- external call to action -->
      <slot name="read-more"></slot>
    </footer>
  </section>  
</template>

<script> 

export default {
  name: 'review',
  props: {
    rating: Number,
    date: String,  
    additional_data: String, 
    max_rating: Number, 
    reviewer: String, 
    title: String, 
    content: String,
    truncate: {
      type: Boolean, 
      default: false,
    }
  },  
  computed: {
    reviewer_initials() {  
      return (this.reviewer || '')
        .split(' ')
        .slice(0, 2)
        .map(part => part.length ? part[0].toUpperCase() : '')
        .join('')
    }
  }
}
</script>

<style lang="scss" scoped> 
.review {
  border-radius: $border-radius-lg * 2;
  display: flex;
  flex-direction: column;
  background-color: white;
  height: 100%;

  &__header {
    padding: $grid-gutter-width / 3;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  &__main {
    padding: 0 $grid-gutter-width / 3;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    gap: $grid-gutter-width / 6;
  }
  
  &__footer {
    display: flex;
    justify-content: flex-end;
  }

  &__user {
    display: flex;
    gap: $grid-gutter-width / 3;
    align-items: center;
  }
  
  &__avatar { 
    line-height: 0;

    background-color: #0A76BD;
    color: white;
    font-weight: $vb-font-weight-semibold;  
    
    display: flex;
    align-items: center;
    justify-content: center;

    overflow: hidden;
    border-radius: 50%;

    max-width: 30px;
    max-height: 30px;
    min-width: 30px;
    min-height: 30px; 
  }

  &__data {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    &-date {
      padding: 0 5px;
      font-size: $font-size-sm;
    }
    &-rating { 
      line-height: 1;
      padding: 0 5px;
      font-weight: $vb-font-weight-semibold;  
    }
  }


  &__name,
  &__title {
    font-size: $font-size-lg;
    font-weight: $vb-font-weight-semibold;
  }

  &__content {
    padding: 0;
  }

  &__content-preview { 
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3; /* Limita a 3 righe */

    box-orient: vertical;
    line-clamp: 3;

    overflow: hidden;
    text-overflow: ellipsis; 
  }

  &__additional{
    margin: 0;
    line-height: 0;     
    padding: 0 5px;
    font-size: $font-size-sm;
    font-style: italic;
  }
 
}
</style>